// This file is only a template for Stores.  Copy and paste this to your application store .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for Stores is "[App Name]Store.ts" i.e. UserStore.ts, EntitlementStore.ts

import NodeEvents from 'events';
import CommonMessages from '../../../common/CommonMessages';
import assign from 'object-assign';
import UserProfileConstants from './../constants/UserProfileConstants';
import Dispatcher from './../../../flux/AppDispatcher';
var AppDispatcher = Dispatcher.get(UserProfileConstants.PROFILE_DISPATCHER);


var EventEmitter = NodeEvents.EventEmitter;

var CHANGE_EVENT = 'UserProfile.change';
var _profile: IUserProfile = getBlankProfile(),
    _editProfile: IUserProfile | any = getBlankProfile(),
    _passwordSettings: IPasswordSettings = null,
    _hasChanges = false,
    _modalVisible = false,
    _validation: IValidationStoreObject = getEmptyValidation();

function getEmptyValidation() {
    var validation: IValidationStoreObject = {};
    validation[UserProfileConstants.PROFILE_MAIN_PAGE] = {};
    return validation;
}

function getBlankProfile(): IUserProfile {
    return { FirstName: "", LastName: "", UserName: "", Email: "", PasswordExpired: false, ExternalAccountUserName: "", AuthenticationMode: "", ExternalProviderName:"" }; 
}

function _updateObject(comp: string, key: string, value: any) {
    switch (comp) {
        case UserProfileConstants.PROFILE_MAIN_PAGE:
            _updateProfile(key, value);
            _hasChanges = true;
            break;
    }
}

function _validate(comp: string) {
    switch (comp) {
        case UserProfileConstants.PROFILE_MAIN_PAGE:
            _ensureValidObject(comp, _editProfile);
            return _validateObject(UserProfileConstants.PROFILE_MAIN_PAGE);
    }

    return false;
}

function _ensureValidObject(comp: string, obj: any) {
    for (var k in obj) {
        var objType = typeof (obj[k]);
        if (objType !== 'function') {
            if (obj[k] === null || objType !== 'object') {
                _updateProfile(k, obj[k]);
            } else {
                _ensureValidObject(comp, obj[k]);
            }
        }
    }
}

function _updateProfile(name: string, value: string) {
    switch (name) {
        case "UserName":
            _editProfile["UserName"] = value;
            if (value) {
                _setValidValidation(UserProfileConstants.PROFILE_MAIN_PAGE, name);
            } else {
                _validation[UserProfileConstants.PROFILE_MAIN_PAGE][name].invalidValueMessage = CommonMessages.Validation.Required;
                _validation[UserProfileConstants.PROFILE_MAIN_PAGE][name].invalidValue = true;
            }
        default:
            _editProfile[name] = value;
            _setValidValidation(UserProfileConstants.PROFILE_MAIN_PAGE, name);
            break;
    }
}

function _setValidValidation(comp: string, name: string) {
    if (_validation[comp][name]) {
        _validation[comp][name].invalidInput = false;
        _validation[comp][name].invalidValue = false;
    } else {
        _validation[comp][name] = _getNewValidationObject();
    }
}

function _validateObject(comp: string) {
    var ret = true;

    for (var k in _validation[comp]) {
        if (_validation[comp][k].invalidValue) {
            return false;
        }
    }

    return ret;
}

function _getNewValidationObject() {
    return {
        invalidInput: false,
        invalidValue: false
    } as IValidationObject;
}

function _initalizeValidation(comp: string) {
    switch (comp) {
        case UserProfileConstants.PROFILE_MAIN_PAGE:

            var valiObj: IValidationDictionaryObject = _validation[UserProfileConstants.PROFILE_MAIN_PAGE] = {};

            for (var k in _editProfile) {
                _setValidValidation(UserProfileConstants.PROFILE_MAIN_PAGE, k);
            }
            break;
    }
}

function validationError(comp: string, messageObj: IErrorMessageObject) {
    if (messageObj.propertyName === "EmailAddress") {
        // Convert from web api property to UI.
        messageObj.propertyName = 'Email';
    }

    _validation[comp][messageObj.propertyName].invalidValueMessage = messageObj.message;
    _validation[comp][messageObj.propertyName].invalidValue = true;
}

function setProfile(profile: IUserProfile) {
    _profile = profile;
    _editProfile = $.extend({}, profile);
    _hasChanges = false;
    _initalizeValidation(UserProfileConstants.PROFILE_MAIN_PAGE);
}

var UserProfileStore: IUserProfileStore = assign({}, EventEmitter.prototype, {
    getProfile: function () {
        return _profile;
    },
    getEditProfile: function() {
        return _editProfile;
    },
    getPasswordSettings: function () {
        return _passwordSettings;
    },
    getHasChanges: function () {
        return _hasChanges;
    },
    getModalVisible: function () {
        return _modalVisible;
    },
    getValidation(key: string) {
        return _validation[key];
    },
    getIsValidObject(key: string) {
        return _validate(key);
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback:any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

AppDispatcher.register(function (payload:any) {
    switch (payload.actionType) {
        case UserProfileConstants.PROFILE_GET:
            setProfile(payload.profile);
            break;
        case UserProfileConstants.PROFILE_UPDATE:
            setProfile(_editProfile);
            break;
        case UserProfileConstants.PROFILE_UPDATE_PASSWORD:
            
            break;
        case UserProfileConstants.PROFILE_GET_PASSWORD_SETTINGS:
            _passwordSettings = payload.settings
            break;
        case UserProfileConstants.PROFILE_UPDATE_PASSWORD_SUCCESS:

            break;
        case UserProfileConstants.PROFILE_UPDATE_OBJECT:
            _updateObject(payload.component, payload.key, payload.value);
            break;
        case UserProfileConstants.PROFILE_CANCEL_CHANGES:
            setProfile(_profile);
            break;
        case UserProfileConstants.PROFILE_VALIDATION_ERROR:
            validationError(payload.component, payload.messageObj);
            break;
        default: return true;
    }

    UserProfileStore.emitChange();

    return true;
});

export default UserProfileStore;